import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import type React from "react"
import { LightTooltip } from "../LocationDetails/LocationRisk/Shared"
import {
  NWSS_SCOPE_EVENT_LABEL,
  NWSS_SCOPE_EVENT_TOOLTIP,
  NWSS_SCOPE_HISTORIC_LABEL,
  NWSS_SCOPE_HISTORIC_TOOLTIP,
} from "./nwssDisplayFormat"
import { nwssScopeToggleGroupSx } from "./precomputedDrawerStyles"
import type { NwssDrawerSampleScope } from "./nwssDrawerScope"

export interface NwssSampleScopeToggleProps {
  scope: NwssDrawerSampleScope
  onScopeChange: (scope: NwssDrawerSampleScope) => void
}

export const NwssSampleScopeToggle: React.FC<NwssSampleScopeToggleProps> = ({
  scope,
  onScopeChange,
}) => (
  <ToggleButtonGroup
    size="medium"
    exclusive
    value={scope}
    onChange={(_event, value: NwssDrawerSampleScope | null) => {
      if (value != null) onScopeChange(value)
    }}
    sx={nwssScopeToggleGroupSx}
  >
    <ScopeToggleButton
      value="historic"
      label={NWSS_SCOPE_HISTORIC_LABEL}
      tooltip={NWSS_SCOPE_HISTORIC_TOOLTIP}
    />
    <ScopeToggleButton
      value="event"
      label={NWSS_SCOPE_EVENT_LABEL}
      tooltip={NWSS_SCOPE_EVENT_TOOLTIP}
    />
  </ToggleButtonGroup>
)

interface ScopeToggleButtonProps {
  value: NwssDrawerSampleScope
  label: string
  tooltip: string
}

const ScopeToggleButton: React.FC<ScopeToggleButtonProps> = ({
  value,
  label,
  tooltip,
}) => (
  <LightTooltip arrow placement="top" title={tooltip}>
    <span>
      <ToggleButton value={value} sx={{ textTransform: "none" }}>
        {label}
      </ToggleButton>
    </span>
  </LightTooltip>
)
